import { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';

// Third-party packages.
import Helmet from 'react-helmet';

import * as dayjs from 'dayjs';
import * as isoWeek from 'dayjs/plugin/isoWeek';

// Types.
import InstanaIntegration from '../../../../types/integration/InstanaIntegration';

// Constants.
import { DATA_LOADING, DATA_LOADED } from '../../../../component/Constants';

// Apis.
import IntegrationsApi from '../../../../api/IntegrationApi';

// Views.
import List from './List';
import Detail from './Detail';
import Breadcrumb from "../../../../container/breadcrumb";
import IntegrationTrail from "../../../../container/breadcrumb/IntegrationTrail";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";
import { InstanaIntegrationContext } from "../../../../context/InstanaIntegrationContext";

// DayJS plugins - note, the position of these in this file are important.
dayjs.extend(isoWeek.default);

interface IInstanaProps {
    instanaIntegrations: InstanaIntegration[],
    toggleMenu: Function,
    isAdmin: boolean
}

interface IInstanaState {
    loading: number,
    instanaIntegrations: InstanaIntegration[],
    instanaIntegration: InstanaIntegration
}

const initialState: IInstanaState = {
    loading: DATA_LOADING,
    instanaIntegrations: [],
    instanaIntegration: {
        id: 0,
        name: '',
        host: '',
        apikey: ''
    }
};

class Instana extends Component<IInstanaProps, IInstanaState> {
    static propTypes: {  toggleMenu: PropTypes.Validator<(...args: any[]) => any>, isAdmin: PropTypes.Validator<boolean>; };
    static contextType = InstanaIntegrationContext;

    constructor(props: IInstanaProps) {
        super(props);

        this.state = initialState;
    };

    componentDidMount() {
        this.getInstanaIntegrations();
    }

    async getData() {
        this.setState({
            loading: DATA_LOADING
        });
        this.getInstanaIntegrations();


    }

    async getInstanaIntegrations() {

        // Get integrations.
        const instanaIntegrations: InstanaIntegration[] = await IntegrationsApi.getIntegrations();

        this.setState({
            loading: DATA_LOADED,
            instanaIntegrations
        });
    }

    /* Action Methods */

    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, instanaIntegrations, instanaIntegration } = this.state;


        return (
            <div id="content">
                <Helmet>
                    <title>Instana - Settings - DBmarlin</title>
                    <meta name="description" content="Manage your Instana integrations" />
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                    <Breadcrumb heading="Instana">
                        {[<IntegrationTrail key="instana-trail" section="Instana"
                                            sectionPath="/admin/integrations/instana"
                                            resolveEntityLabel={(id) =>
                                                instanaIntegrations.find(integration =>
                                                    integration.id === Number(id))?.name}/>]}
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh} />
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"></div>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} isAdmin={this.props.isAdmin} />} />
                        <Route path="/:actionId/:instanaId" element={<Detail refresh={this.refresh} isAdmin={this.props.isAdmin} />} />
                        <Route path="/" element={<List loading={loading} instanaIntegrations={instanaIntegrations} instanaIntegration={instanaIntegration} refresh={this.refresh} isAdmin={this.props.isAdmin} />} />
                    </Routes>
                </div>
            </div>
        );
    }
}

Instana.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default Instana;
